import { Base } from "@app/controllers/base";
import "@js/plugins/select2/main.js"

export default class extends Base {
  static values = {
    config:      Object,
    url:         String,
    placeholder: String,
  };

  connect() {
    this.$select = $(this.element);

    const options = {
      width: "100%",
      ...this.configValue,
    };

    if (this.hasUrlValue) {
      options.ajax = {
        url:      this.urlValue,
        dataType: "json",
        delay:    250,
        data:     (params) => {
          return {
            q:    params.term, // search term
            page: params.page,
          };
        },
        processResults: (data) => {
          const results = data.results || data;
          return {
            results: results,
          };
        },
        cache: true,
      };

      if (this.hasPlaceholderValue) {
        options.placeholder = this.placeholderValue;
        options.allowClear = true;
      }
    }

    this.$select.select2(options);

    // Select2 fires jQuery events, not native DOM events.
    // Re-dispatch as a native event so Stimulus data-action="change->..." listeners fire.
    // Using select2:select/unselect/clear (not "change") avoids an infinite loop —
    // "change" would be caught by jQuery again, triggering another native dispatch.
    this.$select.on("select2:select select2:unselect select2:clear", () => {
      this.element.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  disconnect() {
    if (this.$select) {
      this.$select.off("select2:select select2:unselect select2:clear");
      if (this.$select.hasClass("select2-hidden-accessible")) {
        this.$select.select2("destroy");
      }
    }
  }
}
